module.exports = __webpack_public_path__ + "static/media/pk_soil.ec983c3e.jpg";